export default __webpack_public_path__ + "static/gmail-89bc1e1c86a93729884ff1070a8dbc1d.png";